import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { Utilities } from '@shared/utilities/utilities.model';

import { ErrorPage, ErrorPageService } from '@shared/service/error-page.service';
import {
	ROOT_DELIVERY,
	ROOT_CONTRACT_CLOSING,
	ROOT_PROFILE,
	ROOT_NOTIFICATION_CENTER,
	ROOT_CONTRACT_CLOSING_SP,
	ROOT_CONTRACT_CLOSING_ALD,
	ROOT_CONTRACT_CLOSING_DK_OP,
	ROOT_CONTRACT_CLOSING_DK_C,
	ROOT_DELIVERY_ASR,
	ROOT_AUTHORITY,
	ROOT_REDIRECT
} from '../../../app-routing-roots';

@Component({
	selector: 'amd-empty-redirect',
	templateUrl: './empty-redirect.component.html',
	styleUrls: ['./empty-redirect.component.css']
})
export class EmptyRedirectComponent implements OnInit {

	constructor(public location: Location,
		public router: Router,
		private route: ActivatedRoute,
		public errorService: ErrorPageService) {
	}

	ngOnInit() {
		this.goToRoot();
	}

	goToRoot() {
		const path = this.location.path();
		const routes = path.split('/');
		let route = '/';
		if (routes.length > 1) {
			const root = routes[1];
			if (this.isValidRoot(root)) {
				route += root;
				this.errorService.pushErrorPage(null);
			} else if (root.includes(ROOT_AUTHORITY)) {
				route = this.route.snapshot.queryParams.url || '/';
			} else if (root === ROOT_CONTRACT_CLOSING) {
				if (routes.length > 3) {
					const subRout = routes[3];
					if (this.isValidRoot(root + '/' + subRout)) {
						route += root + '/' + subRout;
						this.errorService.pushErrorPage(null);
					}
				}
			} else if (!root.includes(ROOT_REDIRECT)) {
				this.errorService.pushErrorPage(ErrorPage.get404ErrorPage());
				return;
			}
		}
		this.router.navigate([route]);
	}

	private isValidRoot(root: string) {
		return !Utilities.isVoid(root) &&
			(root === ROOT_DELIVERY || root === ROOT_DELIVERY_ASR || root === ROOT_PROFILE || root === ROOT_NOTIFICATION_CENTER
				|| root === ROOT_CONTRACT_CLOSING_ALD || root === ROOT_CONTRACT_CLOSING_DK_OP
				|| root === ROOT_CONTRACT_CLOSING_DK_C || root === ROOT_CONTRACT_CLOSING_SP);
	}
}
